import React from "react";

const SvgSmallGlare = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="SmallGlare_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#SmallGlare_svg__a)">
      <path
        d="M44.08 33.53l.15-.12c-.39.31 0 0 .18-.13q.78-.58 1.58-1.14a10.38 10.38 0 0 1 3.06-1.69c2.36-.47 1.36-4.09-1-3.62-2.36.47-4.74 2.55-6.63 4a1.89 1.89 0 0 0 0 2.65 1.92 1.92 0 0 0 2.65 0l.01.05z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgSmallGlare;